(() => {
  if (customElements.get('vorug-editorial-footer')) return;
  class VorugEditorialFooter extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const {signal} = this.abort;
      const directory = this.querySelector('.vf-directory');
      const vorug = directory?.querySelector('[aria-labelledby="vf-directory-vorug"]');
      const support = directory?.querySelector('[aria-labelledby="vf-directory-support"]');
      const community = directory?.querySelector('[aria-labelledby="vf-directory-community"]');
      const contact = directory?.querySelector('.vf-directory-contact');
      if (vorug && support && community && contact) {
        const media = matchMedia('(max-width:1023px)');
        const syncDirectory = () => {
          const focused = this.contains(document.activeElement) ? document.activeElement : null;
          const order = media.matches ? [support, vorug, community, contact] : [vorug, support, community, contact];
          order.forEach((node, index) => {
            if (directory.children[index] !== node) directory.insertBefore(node, directory.children[index] || null);
          });
          this.toggleAttribute('data-vf-support-first', media.matches);
          if (focused?.isConnected && document.activeElement !== focused) focused.focus({preventScroll:true});
        };
        media.addEventListener('change', syncDirectory, {signal});
        syncDirectory();
      }
      const form = this.querySelector('.vf-form');
      if (!form) return;
      const button = form.querySelector('button[type=submit]');
      const pending = form.querySelector('[data-vf-pending]');
      const reset = () => {
        this.submitting = false;
        form.removeAttribute('aria-busy');
        button.disabled = false;
        pending.hidden = true;
      };
      reset();
      window.addEventListener('pageshow', reset, {signal});
      form.addEventListener('submit', event => {
        if (this.submitting) {
          event.preventDefault();
          return;
        }
        // Preserve Shopify's native submit and CAPTCHA handling.
        queueMicrotask(() => {
          if (event.defaultPrevented || !form.isConnected) return;
          this.submitting = true;
          form.setAttribute('aria-busy', 'true');
          button.disabled = true;
          pending.hidden = false;
        });
      }, {signal});
    }
    disconnectedCallback() {
      this.abort?.abort();
    }
  }
  customElements.define('vorug-editorial-footer', VorugEditorialFooter);
})();



(() => {if(document.querySelector('[data-vorug-native-menu]'))return;if(!document.querySelector('[data-vorug-native-footer]'))return;const $=s=>document.querySelector('.vorug-native '+s),$$=s=>[...document.querySelectorAll(s.split(',').map(x=>'.vorug-native '+x.trim()).join(','))];const media=matchMedia('(max-width:1023px)'),reducedMotion=matchMedia('(prefers-reduced-motion:reduce)'),running=new Map(),motionStyle=getComputedStyle(document.querySelector('[data-vorug-native-footer]'));const motion={open:240,close:140,switch:200,detail:160,ease:'cubic-bezier(.22,1,.36,1)'};function stopMotion(el){const old=running.get(el);if(old){running.delete(el);old.animation.cancel()}}
function animateSurface(el,frames,kind='open',complete=()=>{}){
 stopMotion(el);
 if(reducedMotion.matches||!el.animate){complete();return}
 const animation=el.animate(frames,{duration:motion[kind],easing:motion.ease,fill:'both'});
 const entry={animation,complete};running.set(el,entry);
 animation.onfinish=()=>{if(running.get(el)!==entry)return;running.delete(el);animation.cancel();complete()};
}
function surfaceStyle(el){const style=getComputedStyle(el);return {opacity:style.opacity,transform:style.transform}}
function reveal(el,{x=0,y=-6,kind='open'}={}){
 const start=el.hidden?{opacity:0,transform:`translate(${x}px,${y}px)`}:surfaceStyle(el);
 el.hidden=false;el.inert=false;
 animateSurface(el,[start,{opacity:1,transform:'none'}],kind);
}
function conceal(el,{immediate=false,y=-4,complete=()=>{}}={}){
 if(el.hidden){stopMotion(el);complete();return}
 const start=surfaceStyle(el);el.inert=true;
 const settle=()=>{el.hidden=true;el.inert=false;complete()};
 if(immediate){stopMotion(el);settle();return}
 animateSurface(el,[start,{opacity:0,transform:`translateY(${y}px)`}],'close',settle);
}
reducedMotion.addEventListener('change',()=>{if(!reducedMotion.matches)return;for(const [el,entry] of [...running]){running.delete(el);entry.animation.cancel();entry.complete()}});

function clearFooterMotion(links){
 stopMotion(links);links.style.removeProperty('overflow');links.inert=false;
}
function toggleFooter(b){
 if(!media.matches)return;
 const opening=b.getAttribute('aria-expanded')!=='true',column=b.closest('.footer-column'),links=$('#'+b.getAttribute('aria-controls'));
 // Capture the currently rendered frame before canceling; rapid reversals start here.
 const startHeight=links.getBoundingClientRect().height,startStyle=getComputedStyle(links),startOpacity=startHeight?startStyle.opacity:0,startPadding=startHeight?startStyle.paddingBottom:'0px';
 stopMotion(links);column.classList.add('expanded');links.style.overflow='hidden';
 const fullHeight=links.getBoundingClientRect().height,fullPadding=getComputedStyle(links).paddingBottom;
 b.setAttribute('aria-expanded',opening);links.inert=!opening;
 animateSurface(links,[{height:startHeight+'px',paddingBottom:startPadding,opacity:startOpacity},{height:(opening?fullHeight:0)+'px',paddingBottom:opening?fullPadding:'0px',opacity:opening?1:0}],opening?'detail':'close',()=>{
  column.classList.toggle('expanded',opening);links.style.removeProperty('overflow');links.inert=false;
 });
}
$$('.footer-toggle').forEach(b=>b.addEventListener('click',()=>toggleFooter(b)));
const footerShopAll=$('#vn19-footer-shop a:first-child');if(footerShopAll&&!footerShopAll.querySelector('.icon'))footerShopAll.insertAdjacentHTML('beforeend','<svg class="icon" aria-hidden="true"><use href="#vn19-i-arrow"/></svg>');
let footerFocus=null;
document.addEventListener('focusin',e=>{footerFocus=e.target.closest('.footer-links a,.mobile-contact')});
function syncFooter(){
 const mobile=media.matches;
 // CSS can blur a hidden link before the media-query change event reaches us.
 let focused=document.activeElement===document.body?footerFocus:document.activeElement;
 if(mobile&&focused?.matches('#vn19-footer-help a[data-destination="Contact"]')){$('.mobile-contact').focus({preventScroll:true});focused=null;}
 else if(!mobile&&focused?.matches('.mobile-contact')){$('#vn19-footer-help a[data-destination="Contact"]').focus({preventScroll:true});focused=null;}
 // Keep a focused destination visible when resizing from desktop to mobile.
 $$('.footer-toggle').forEach(b=>{
  const links=$('#'+b.getAttribute('aria-controls')),column=b.closest('.footer-column');
  if(running.has(links)&&b.getAttribute('aria-expanded')==='false')column.classList.remove('expanded');
  if(mobile&&links.contains(focused))column.classList.add('expanded');
  clearFooterMotion(links);b.setAttribute('aria-disabled',String(!mobile));b.tabIndex=mobile?0:-1;b.setAttribute('aria-expanded',mobile?column.classList.contains('expanded'):'true');
  if(mobile&&links.contains(focused)&&document.activeElement!==focused)focused.focus({preventScroll:true});
 });
}syncFooter();

media.addEventListener('change',syncFooter);})();